"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBulkUpdatePriorityTasks = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const bulk_update_priority_tasks_mutation_1 = require("../bulk-update-priority-tasks.mutation");
const useBulkUpdatePriorityTasks = () => {
    const [bulkUpdatePriorityTasksMutation, { loading, error }] = (0, react_2.useMutation)(bulk_update_priority_tasks_mutation_1.BULK_UPDATE_PRIORITY_TASKS);
    const bulkUpdatePriorityTasks = (0, react_1.useCallback)((input) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const result = yield bulkUpdatePriorityTasksMutation({
            variables: { input },
            fetchPolicy: 'no-cache',
        });
        const data = (_a = result.data) === null || _a === void 0 ? void 0 : _a.bulkUpdatePriorityTasks;
        if (data === null || data === void 0 ? void 0 : data.error) {
            throw new Error(data.error);
        }
        return data;
    }), [bulkUpdatePriorityTasksMutation]);
    return {
        bulkUpdatePriorityTasks,
        loading,
        error,
    };
};
exports.useBulkUpdatePriorityTasks = useBulkUpdatePriorityTasks;
